import axios from 'axios' // 引入axios模块
import router from '../router/router';
import {
    Message
} from "element-ui";

// 环境的切换
if (process.env.NODE_ENV == 'development') {
    //axios.defaults.baseURL = 'https://jianyouexp.risfond.com';
    //axios.defaults.baseURL = 'http://192.168.30.7:8095';
    axios.defaults.baseURL = 'http://localhost:8101';
    //    axios.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
    //axios.defaults.baseURL = 'http://192.168.30.7:8095';
    axios.defaults.baseURL = 'https://jianyouexp.risfond.com';
    //axios.defaults.baseURL = 'http://localhost:8101';
    //axios.defaults.baseURL = 'http://testjianyouexp.risfond.com';
}
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 添加请求拦截器
axios.interceptors.request.use(config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断

    if (sessionStorage.token) {
        config.headers.Authorization = sessionStorage.token;
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});


// 添加响应拦截器
axios.interceptors.response.use(response => {
    // 对响应数据做点什么
    if (response.status === 200) {
        return Promise.resolve(response)
    } else {
        return Promise.reject(response)
    }
    return response;
}, error => {
    if (error.response.status) {
        switch (error.response.status) {
            // 401: 未登录
            // 未登录则跳转登录页面，并携带当前页面的路径
            // 在登录成功后返回当前页面，这一步需要在登录页操作。
            case 401:
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                })
                break;
            // 403 token过期
            // 登录过期对用户进行提示
            // 清除本地token和清空vuex中token对象
            // 跳转登录页面
            case 403:
                Message({
                    message: '登录过期，请重新登录',
                    duration: 2000,
                    showIcon: false
                })
                sessionStorage.removeItem('token')
                sessionStorage.removeItem('seconds')
                setTimeout(() => {
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    })
                }, 1000);
                break;
            // 404请求不存在
            case 404:
                Message({
                    message: '网络请求不存在',
                    duration: 2000,
                })
                break;

            default:
                Message({
                    message: error.response.data.message,
                    duration: 2000,
                })
                break;
        }
    }
    return Promise.reject(error);
});

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            });
    })
}

export function post(url, params) {

    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            });
    })
}



// WEBPACK FOOTER //
// ./src/api/http.js